import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from 'src/shared/interceptors/auth.interceptor';
import { HttpErrorInterceptor } from 'src/shared/interceptors/http-error.interceptor';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpLoaderInterceptor } from 'src/shared/interceptors/http-loader.interceptor';
import { LanguageService } from 'src/shared/services/language.service';
import { ServiceWorkerModule } from '@angular/service-worker';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: location.hostname !== 'localhost',
      // Opcional: espera a que la app esté estable antes de registrar el SW
      registrationStrategy: 'registerWhenStable:30000'
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
  ],
  exports: [],
  providers: [
    LanguageService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpLoaderInterceptor,multi: true }, // Implementar interceptor de carga en la aplicación
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, // Implementar interceptor de autenticación en la aplicación
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }, // Implementar interceptor de captura de errores en la aplicación
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private translateService: TranslateService) {}
}
